/**
 * This file is a component for E2 UI Customization (This is subject to change based off of mediaType)
 */

import React, {useState, useEffect} from 'react';
import { Grid, Tooltip, FormControlLabel, Checkbox} from '@material-ui/core';
import DesktopAccessDisabledIcon from '@material-ui/icons/DesktopAccessDisabled';

export default function DisableNotes(props)
{
    const [disableNotes, setDisableNotes] = useState(false);

    /** Set activity panel to value being passed through props */
    useEffect(() => {
        setDisableNotes(props.value);
    },[props.value]);
    
    /**Handle changes to activity panel checkbox */
    const handleDisableNotes = () => {
        setDisableNotes(!disableNotes);
        props.onChange(!disableNotes)
    }

    return(
        <div>
            <Grid container direction="row" alignItems="center">
                <Grid item>
                    <FormControlLabel
                    control={
                        <Checkbox
                        checked={disableNotes}
                        onChange={handleDisableNotes}
                        name="disableNotes"
                        color="primary"
                        />
                    }
                    label="Disable Disposition Notes"
                    />
                </Grid>
                <Grid item>
                    <Tooltip title="Disables Disposition Notes">
                        <DesktopAccessDisabledIcon color="primary"/>
                    </Tooltip>
                </Grid>
            </Grid>
        </div>
    );
}

